import type { ReactNode } from "react";

type Props = {
  title: string;
  subtitle?: string;
  actions?: ReactNode;
  greeting?: boolean;
};

export function PageHeader({ title, subtitle, actions, greeting }: Props) {
  return (
    <header
      className={`page-header ${greeting ? "page-header--greeting" : ""}`.trim()}
      data-vt-page-header
    >
      <div className="page-header__text">
        <h1>{title}</h1>
        {subtitle && <p>{subtitle}</p>}
      </div>
      {actions && <div className="page-header__actions">{actions}</div>}
    </header>
  );
}
